<template>
  <div
    class="flex flex-wrap gap-2 py-4 md:py-0 w-full justify-center max-h-62 overflow-y-auto md:max-h-none"
  >
    <BaseButton
      v-for="cat in filteredCategories"
      :key="cat.id"
      @click="() => handleClick(cat.name)"
      color="muted"
      class="px-3 py-1 max-w-full min-w-0"
      :class="{
        '!border-primary': router.currentRoute.value.query.category === cat.name,
      }"
      ><span class="block max-w-[400px] overflow-hidden text-ellipsis whitespace-nowrap">{{ getLocalizedCategoryValue(cat, locale, 'name') }}</span></BaseButton
    >
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  import BaseButton from '@/components/ui/BaseButton.vue';
  import { useGeneralStore } from '@/stores/general';
  import { getLocalizedCategoryValue } from '@/utils/getCategoryLocalization';

  const emit = defineEmits(['onChange']);

  const generalStore = useGeneralStore();
  const { locale } = useI18n();
  const categories = computed(() => generalStore.categories());
  const events = computed(() => generalStore.events());

  // Also filter out duplicate names and categories without events
  // to avoid cluttering the filter with useless options
  // And sort alphabetically
  
  const filteredCategories = computed(() => {
    return categories.value
      .filter(category => {
        if (category.hide_from_list){
          return false
        }

        // Filter out categories that don't support the active language
        if (!category.languages.includes(locale.value)) {
          return false;
        }

        // Check if the category has events associated with it in the active language
        if (events.value.some(event => event.languages.includes(locale.value) && event.categories?.includes(category.id))){
          return true
        }
        return false;
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  });

  const router = useRouter();

  const handleClick = (category: string) => {
    const currentQuery = { ...router.currentRoute.value.query };
    const newQuery = { category: undefined as string | undefined };
    if (currentQuery.category !== category) {
      newQuery.category = category;
    }
    router.push({
      path: '/',
      query: newQuery,
    });
    
    emit('onChange');
  };
</script>
